<template>
  <div class="about">
    <back-home-btn></back-home-btn>

    <v-container class="pa-3 pt-5">
      <h2 class="text-h4">余韻の米蔵について</h2>
      <v-card class="pa-5 mt-3">
        <v-row>
          <template v-for="(item, index) in items">
            <v-col
              :key="`title${index}`"
              cols="12"
              class="text-h6 font-weight-bold pb-1"
            >
              {{ item.title }}
            </v-col>
            <v-col
              :key="`content${index}`"
              cols="12"
              class="text-body-2 pt-1"
            >
              <div>{{ item.content }}</div>
              <div>{{ item.subcontent }}</div>
            </v-col>
          </template>
        </v-row>
      </v-card>
    </v-container>

  </div>
</template>

<script>
import BackHomeBtn from '../components/parts/BackHomeBtn.vue'

export default {
  components: {
    BackHomeBtn,
  },
  data: () => ({
    items: [
      { title: '余韻の米蔵とは', content: '株式会社今井農園の自社ブランド「八ヶ岳の余韻」の商品を販売するオンラインストアです。', subcontent: '' },
      { title: '八ヶ岳の余韻 -Yatsu no Yoin- のコンセプト', content: '水と空気、太陽に恵まれた八ヶ岳南麓には、その気候や風土の"恩恵"がたくさんあります。', subcontent: '今井農園はその中から"八ヶ岳南麓で過ごしたひとときを、ご家庭でも感じられるもの"を選び、商品としました。' },
      { title: '推奨環境', content: 'PC/Mac：Google Chrome、Edge、Safariなど', subcontent: 'スマホ/タブレット：Google Chrome、Safariなど' },
    ],
  }),
}
</script>